module.exports = __webpack_public_path__ + "static/media/image05.bef6e718.png";